const HISTORY = new Set();

function logLevelOnce(level, msg, ...args) {
  if (!HISTORY.has(msg)) {
    HISTORY.add(msg);
    console[level].call(console, msg, ...args);
  }
}

export function logOnce(msg, ...args) {
  logLevelOnce('log', msg, ...args);
}

export function logWarnOnce(msg, ...args) {
  logLevelOnce('warn', msg, ...args);
}

export function logErrorOnce(msg, ...args) {
  logLevelOnce('error', msg, ...args);
}
